import { render, staticRenderFns } from "./bondnews.vue?vue&type=template&id=c07731b2&scoped=true&"
import script from "./bondnews.vue?vue&type=script&lang=js&"
export * from "./bondnews.vue?vue&type=script&lang=js&"
import style0 from "./bondnews.vue?vue&type=style&index=0&id=c07731b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07731b2",
  null
  
)

export default component.exports